// extracted by mini-css-extract-plugin
export default {"badge":"ThemeBadge_badge__Z+JVD"};